// Consultant Profile API
// API helpers for fetching and updating consultant profile data

import { API_CONFIG } from '../../config/api';
import {
  ConsultantProfile,
  ConsultantProfileResponse,
  UpdateConsultantProfileRequest,
  UpdateConsultantProfileResponse,
  ApiError
} from './types';

/**
 * Get consultant profile data
 */
export const getConsultantProfile = async (token: string): Promise<ConsultantProfileResponse> => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/api/users/consultant-profile`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch consultant profile');
    }

    return data;
  } catch (error) {

    throw error;
  }
};

/**
 * Update consultant profile data
 */
export const updateConsultantProfile = async (
  token: string,
  profileData: UpdateConsultantProfileRequest
): Promise<UpdateConsultantProfileResponse> => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}/api/users/consultant-profile`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(profileData)
    });

    const data = await response.json();

    if (!response.ok) {

      throw new Error(data.message || 'Failed to update consultant profile');
    }

    return data;
  } catch (error) {

    throw error;
  }
};

/**
 * Helper function to get auth token from localStorage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};

/**
 * Helper function to handle API errors consistently
 */
export const handleApiError = (error: any): ApiError => {
  if (error.message) {
    return {
      success: false,
      message: error.message
    };
  }

  return {
    success: false,
    message: 'An unexpected error occurred'
  };
};
